import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import Sidebar from "../components/common/Sidebar";
import AlarmListener from "../components/common/AlarmListener";
import TopNavbar from "../components/common/TopNavbar";

import OverviewTab from "../components/admin/tabs/OverviewTab";
import SectorsTab from "../components/admin/tabs/SectorsTab";
import MachinesTab from "../components/admin/tabs/MachinesTab";
import ToolsTab from "../components/admin/tabs/ToolsTab";
import UsersTab from "../components/admin/tabs/UsersTab";
import MaintenanceTab from "../components/admin/tabs/MaintenanceTab";
import StockToolsTab from "../components/admin/tabs/StockToolsTab";
import ShortLifeTime from "../components/admin/tabs/StockShortTab";
import LongLifeTime from "../components/admin/tabs/StockLongTab";
import StockHistoryAdmin from "../components/admin/tabs/StockHistoryAdmin";
import HistoryTab from "../components/admin/tabs/HistoryTab";
import HistoryTools from "../components/admin/tabs/HistoryToolsTab";
import HistoryKaizen from "../components/admin/tabs/HistoryKaizenTab";
import TechniciansTab from "../components/admin/tabs/TechniciansTab";
import StockApprovalTab from "../components/admin/tabs/StockApprovalTab";
import HistoryMesinTab from "../components/maintenance/tabs/HistoryMesinTab";
import ChecksheetTab from "../components/admin/tabs/ChecksheetTab";

import "./AdminDashboard.css";

// ✅ IMPORT YANG BENAR
import { useParams } from "react-router-dom";

const AdminDashboard = () => {
  const { tab } = useParams(); // ambil tab dari URL
  const { currentUser } = useContext(AuthContext);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");

  // Sinkronkan tab dengan URL
  useEffect(() => {
    const validTabs = [
      "overview",
      "sectors",
      "machines",
      "tools",
      "users",
      "history",
      "maintenance",
      "technicians",
      "reports",
      "stocktools",
      "short",
      "long",
      "historystock",
      "historytools",
      "historykaizen",
      "historymesin",
      "stock-approval",
      "checksheet",
    ];

    if (validTabs.includes(tab)) {
      setActiveTab(tab);
    } else {
      setActiveTab("overview");
    }
  }, [tab]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewTab />;
      case "sectors":
        return <SectorsTab />;
      case "machines":
        return <MachinesTab />;
      case "tools":
        return <ToolsTab />;
      case "users":
        return <UsersTab />;
      case "technicians":
        return <TechniciansTab />;
      case "history":
        return <HistoryTab />;
      case "maintenance":
        return <MaintenanceTab />;
      case "stocktools":
        return <StockToolsTab />;
      case "short":
        return <ShortLifeTime />;
      case "long":
        return <LongLifeTime />;
      case "historystock":
        return <StockHistoryAdmin />;
      case "historytools":
        return <HistoryTools />;
      case "historykaizen":
        return <HistoryKaizen />;
      case "historymesin":
        return <HistoryMesinTab />;
      case "stock-approval":
        return <StockApprovalTab />;
      case "checksheet":
        return <ChecksheetTab />;
      default:
        return <OverviewTab />;
    }
  };

  return (
    // AdminProvider sudah dipasang di App.js pada route /admin-dashboard,
    // jadi JANGAN bungkus lagi di sini (dulu dobel → fetch data admin 2x).
    <>
      <AlarmListener role="admin" />
      <div className="dashboard-layout">
        <Sidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          userRole="admin"
          onLogout={handleLogout}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />

        <div className={`main-content ${mobileOpen ? "shifted" : ""}`}>
          <TopNavbar
            activeTab={activeTab}
            currentUser={currentUser}
            handleLogout={handleLogout}
            userRole="admin"
          />

          <div className="dashboard-content">{renderTabContent()}</div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
